import React from "react";
import "../styles/style.css";
import "../styles/VillasSite.css";
import HeaderSerene from "../components/HeaderSerene";
import HeroVillas from "../components/vessellavilla/HeroVillas";
import VillasLogo from "../assets/villas-images/vessella-villas-logo.png";
import AboutWoods from "../components/vessellavilla/AboutVillas";
import AboutWoods1 from "../components/vessellavilla/AboutVillas1";
import Clubhouse from "../components/vessellavilla/ClubHouseWoods";
import WoodsMasterplan from "../components/vessellavilla/VillasMasterplan";
import LocationVillas from "../components/vessellavilla/LocationVillas";
import VillasSpecification from "../components/vessellavilla/VillasSpecification";
import VillasGallery from "../components/vessellavilla/VillasGallery";
import FloorPlansVillas from "../components/vessellavilla/FloorPlansVillas";
import ContactWoods from "../components/vessellavilla/ContactWoods";
import VideoTourVillas from "../components/vessellavilla/VideoTourVillas";

const menuLinks = [
  { label: "ABOUT VILLAS", target: "about-serene" },
  // { label: "AMENITIES", target: "woods-clubhouse" },
  { label: "MASTERPLAN", target: "woods-masterplay" },
  { label: "FLOOR PLANS", target: "villas-floor-plans" },
  { label: "GALLERY", target: "villas-gallery" },
  { label: "VIDEO TOUR", target: "villas-video-tour" },
  { label: "LOCATION", target: "woods-location" },
  { label: "SPECIFICATIONS", target: "serene-specifications" },
  { label: "CONTACT", target: "serene-contact" },
];

function VillasSite() {
  return (
    <section id="home-villas">
      <HeaderSerene logo={VillasLogo} menuLinks={menuLinks} />
      <HeroVillas />
      <AboutWoods />
      <AboutWoods1 />
      {/* <Clubhouse /> */}
      <WoodsMasterplan />
      <FloorPlansVillas />
      <VillasGallery />
      <VideoTourVillas />
      <LocationVillas />
      <VillasSpecification />
      {/* <ApprovedBanks /> */}
      <ContactWoods />
    </section>
  );
}

export default VillasSite;
